import { Radio, RadioGroup } from "@blueprintjs/core";
import { FGCustomInput, FGSelectInput, FGTextInput, FieldGroup } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";

import { EMembershipRequestType, ERequestState, MembershipRequestApi } from "../../../../api";
import { FGSRSHDateMaskInput } from "../../../../components";
import { ERoutes } from "../../../../ERoutes";
import { useApiService, useTl } from "../../../../hooks";
import { useReferential } from "../../../../hooks/useReferential";
import { ETLCodes } from "../../../../locales";
import { DrupalStepperButtonBloc } from "../../../common";
import { DrupalFormGenerator } from "../../../common/DrupalFormGenerator";
import { DrupalFieldSet } from "../../../common/DurpalFieldSet";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export interface IDrupalMembershipFormProps {
  membershipRequestId: number;
  initialdata: any;
  loading: boolean;
}
export const DrupalMembershipForm: React.FunctionComponent<IDrupalMembershipFormProps> = ({
  membershipRequestId,
  loading,
  initialdata,
}) => {
  const { t } = useTl();
  const history = useHistory();
  const api = useApiService(MembershipRequestApi);
  const [Membershiptype, mtloading] = useReferential((a) => a.getMembershipTypes(1), true, []);
  const [membershipRequestTypes] = useReferential((a) => a.getMembershipRequestType(1), true, []);
  const [Decisions, dloading] = useReferential((a) => a.getMembershipDecisions(1), true, []);

  const [membershipRequestTypeCode, setMembershipRequestTypeCode] = React.useState<EMembershipRequestType>(null);
  React.useEffect(() => {
    if (initialdata) {
      api.getMembershipRequestTypeCode(initialdata.typeId).then((e) => {
        setMembershipRequestTypeCode(e);
      });
    }
  }, [api, initialdata]);

  return (
    <DrupalFormGenerator
      initialValues={{ ...initialdata, year: new Date().getFullYear() }}
      editMode={false}
      onSubmit={() => {}}
      loading={loading}
      onCancel={() => history.push(ERoutes.membershipRequest)}
      saving={false}
      hideButtons={true}
    >
      <DrupalFieldSet title={t(ETLCodes.RequestData)}>
        <FGCustomInput label={t(ETLCodes.MembershipRequestType)} name="membershipRequestTypeId">
          {({ formik }) => (
            <RadioGroup
              inline={true}
              selectedValue={formik?.values.membershipRequestTypeId}
              onChange={(c) => {
                formik.setFieldValue("membershipRequestTypeId", +c.currentTarget.value);
              }}
            >
              {membershipRequestTypes?.map((n, index) => (
                <Radio
                  key={index}
                  label={n.label}
                  value={n.value}
                  checked={index === 0 && membershipRequestId <= 0}
                  disabled
                />
              ))}
            </RadioGroup>
          )}
        </FGCustomInput>
        <FieldGroup columns={2}>
          <div>
            <FGSRSHDateMaskInput name="request.requestDate" label={t(ETLCodes.RequestDate)} requiredMark />
            {membershipRequestTypeCode !== EMembershipRequestType.MembershipTypeChange ? (
              <FGSelectInput
                name="membershipInitialTypeId"
                label={t(ETLCodes.MembershipType)}
                items={Membershiptype}
                loading={mtloading}
              />
            ) : (
              <FGCustomInput label={t(ETLCodes.MembershipType)}>
                {() => (
                  <Container>
                    <div style={{ width: "90%", marginRight: "1rem" }}>
                      <FGSelectInput name="membershipInitialTypeId" items={Membershiptype} loading={mtloading} />
                    </div>
                    <i className="fas fa-arrow-right" style={{ marginTop: "0.5rem" }} />
                    <div style={{ width: "90%", marginLeft: "1rem" }}>
                      <FGSelectInput name="membershipFinalTypeId" items={Membershiptype} loading={mtloading} />
                    </div>
                  </Container>
                )}
              </FGCustomInput>
            )}
            {initialdata?.request?.status === ERequestState.EXECUTED && (
              <FieldGroup columns={2}>
                <FGSRSHDateMaskInput name="request.executionDate" label={t(ETLCodes.ClosingDate)} />
              </FieldGroup>
            )}
            {membershipRequestTypeCode === EMembershipRequestType.Renewal && (
              <FGTextInput label={t(ETLCodes.Year)} name="year" />
            )}
          </div>
        </FieldGroup>
      </DrupalFieldSet>
      {membershipRequestTypeCode !== EMembershipRequestType.Renewal && (
        <DrupalFieldSet title={t(ETLCodes.MeetingResult)}>
          <FieldGroup columns={2}>
            <div>
              <FGSRSHDateMaskInput name="meetingDate" label={t(ETLCodes.MeetingDate)} />
              <FGSelectInput
                name="membershipRequestDecisionId"
                label={t(ETLCodes.MeetingDecision)}
                items={Decisions}
                loading={dloading}
              />
              {membershipRequestTypeCode !== EMembershipRequestType.MembershipTypeChange && (
                <FGSelectInput
                  name="membershipFinalTypeId"
                  label={t(ETLCodes.FinalMembershipType)}
                  items={Membershiptype}
                  loading={mtloading}
                />
              )}
            </div>
          </FieldGroup>
        </DrupalFieldSet>
      )}
      <DrupalStepperButtonBloc backOnly={true} />
    </DrupalFormGenerator>
  );
};
